import { useQSet } from '@exam-management/common/qset-provider';
import { QuestionNavigator } from '@exam-management/qset-question-details';
import { Flex } from '@shared/components';

import { useQSetQuestionListSearchParams } from '../../hooks';

import QSetQuestionDetailsNavigatorActions from './qset-question-details-navigator-actions';
import QSetQuestionDetailsNavigatorMenu from './qset-question-details-navigator-menu';

export default function QSetQuestionDetailsNavigator() {
  const [{ page, pageSize }, { goToPage }] = useQSetQuestionListSearchParams();
  const { qSet } = useQSet();
  const { qConfig } = qSet;
  const { totalQuestions } = qConfig;

  return (
    <Flex
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        width: '100%',
        p: theme.spacing(4, 6),
        alignItems: 'center',
        justifyContent: 'space-between',
        borderTop: `1px solid ${theme.palette.grey[100]}`,
      })}
    >
      <QSetQuestionDetailsNavigatorMenu />
      {pageSize === '1' ? (
        <QuestionNavigator
          onJump={(to) => {
            goToPage(to - 1);
          }}
          totalQuestions={totalQuestions}
          currentQuestion={page + 1}
        />
      ) : null}
      <QSetQuestionDetailsNavigatorActions />
    </Flex>
  );
}
